<!--title -->
<app-modal-title
  [title]="formPageConfig.title | translate"
  [isShowClose]="true"
  (isCloseModal)="onClose()"
></app-modal-title>

<div mat-dialog-content class="dialog-content">
  <!-- form -->
  <form [formGroup]="form" autocomplete="off">
    <div class="tw-flex-center flex-column">
      <ng-container *ngIf="type == 'byFile'">
        <p class="tw-mt-1 tw-mb-5 tw-w-full">
          <span
            [innerHTML]="
              'pages.shared.editSendReceiversDeliveryStatus.clickHereToGetASampleFile'
                | translate
            "
          ></span>
        </p>

        <!-- file -->
        <app-mobile-file-uploader
          uniqId="sendReceivers"
          controlName="file"
          [form]="form"
          class="tw-w-full"
          (mobileNumbers)="receivers = $event"
          [isCompressionMobiles]="false"
        >
        </app-mobile-file-uploader>
      </ng-container>

      <!-- oldStatus select search -->

      <delivery-status-select-search
        *ngIf="type == 'all'"
        class="tw-w-full tw-mt-2"
        label="common.currentStatus"
        [scheduledMessageId]="scheduledMessageId"
        [control]="form?.get('oldStatus')"
        [(value)]="oldStatus"
        (onError)="onClose()"
      >
      </delivery-status-select-search>
      <!-- newStatus select search -->
      <delivery-status-select-search
        *ngIf="type == 'getNewDeliveryStatus'"
        class="tw-w-full tw-mt-2"
        label="common.deliveryStatus"
        [scheduledMessageId]="scheduledMessageId"
        [control]="form?.get('newStatus')"
        [(value)]="newStatus"
        (onError)="onClose()"
      >
      </delivery-status-select-search>
      <enum-select-search
        *ngIf="type != 'getNewDeliveryStatus'"
        enumName="DeliveryStatus"
        class="tw-w-full tw-mt-2"
        label="common.changeStatusTo"
        [removable]="false"
        [control]="form?.get('newStatus')"
        [(value)]="newStatus"
      >
      </enum-select-search>
    </div>

    <!-- submit btn -->
    <button
      type="button"
      (click)="onSubmit()"
      mat-ripple
      class="btn tw-w-full tw-mt-3 button-shadow btn-hover-rise"
      [disabled]="loading"
      [themeColor]="'btn'"
    >
      <ng-container *ngIf="!loading">
        <span>{{ "common.edit" | translate }}</span>
      </ng-container>

      <!-- loading -->
      <ng-container *ngIf="loading">
        <span
          class="spinner-border spinner-border-sm"
          role="status"
          aria-hidden="true"
        ></span>
        <span class="sr-only">Loading...</span>
      </ng-container>
    </button>
  </form>
</div>
